import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import ShowArrows from "%/dynamic-components/render-engine/options/carousel/show-arrows";
import ShowDots from "%/dynamic-components/render-engine/options/carousel/show-dots";
import Snap from "%/dynamic-components/render-engine/options/carousel/snap";
import ItemMinWidth from "%/dynamic-components/render-engine/options/carousel/item-min-width";
import ItemMaxWidth from "%/dynamic-components/render-engine/options/carousel/item-max-width";
import AutoScroll from "%/dynamic-components/render-engine/options/carousel/auto-scroll";
import ScrollSpeed from "%/dynamic-components/render-engine/options/carousel/scroll-speed";
import InfiniteScroll from "%/dynamic-components/render-engine/options/carousel/infinite-scroll";
import ItemsPadding from "%/dynamic-components/render-engine/options/carousel/items-padding";

export default class CarouselOptions extends BaseOptionsBundle {

  optionTitle = "Carousel Options";
  static optionClassName = "i-dynamic-carousel";
  inspectorToolGroup = "carousel";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.CAROUSEL_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      ShowArrows,
      ShowDots,
      Snap,
      AutoScroll,
      ScrollSpeed,
      InfiniteScroll,
      ItemMinWidth,
      ItemMaxWidth,
      ItemsPadding,
    ]);
  }
}
